import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49b15b9b")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.documentExecutionCNContainerDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.data?.documentName), 1)
        ]),
        end: _withId(() => [
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _ctx.closeDialog
          }, null, 8, ["onClick"]), [
            [_directive_tooltip, _ctx.$t('common.close')]
          ])
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      (_ctx.data)
        ? (_openBlock(), _createBlock("iframe", {
            key: 0,
            ref: "documentFramePopup",
            name: _ctx.data.iFrameName,
            class: "iframe"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
})